var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { staticClass: "welcome" },
            [
              !_vm.$wf.isSmDown
                ? _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6", xl: "6", grow: "" } },
                    [
                      _c("w-row", { staticClass: "no-margin" }, [
                        _c("h1", [
                          _vm._v(
                            _vm._s(_vm.welcomMsg) + " " + _vm._s(_vm.firstName)
                          ),
                        ]),
                        _c("p", { staticClass: "date-msg" }, [
                          _vm._v(_vm._s(_vm.dateMsg)),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "6", grow: "" } },
                [_c("tiny-account-info")],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _vm.showTabs
                ? _c("w-tabs", {
                    attrs: { value: _vm.selectedTabIndex, tabs: _vm.tabItems },
                    on: {
                      input: function ($event) {
                        return _vm.changeTab($event)
                      },
                    },
                  })
                : _vm._e(),
              _c("w-spacer"),
              !_vm.editMode
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("edit-dashboard"),
                          expression: "$ct('edit-dashboard')",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.setEditMode()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "cog" } })],
                    1
                  )
                : [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("cancel-edit"),
                            expression: "$ct('cancel-edit')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.cancelEdit()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "ban" } })],
                      1
                    ),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("save"),
                            expression: "$ct('save')",
                          },
                        ],
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.saveEdit()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "save" } })],
                      1
                    ),
                  ],
            ],
            2
          ),
          _vm.needsActivation ? _c("app-account-reactivate-email") : _vm._e(),
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c(
                "w-col",
                {
                  attrs: {
                    xs: "12",
                    md: _vm.gridContainerWidth,
                    "no-margin": "",
                    "width-transition": "",
                  },
                },
                [
                  _c(
                    "w-transition-slide-height",
                    [
                      _vm.showQuickAddButtons && _vm.selectedTab
                        ? _c("w-row", [
                            _c(
                              "div",
                              [
                                _c("app-quick-add-buttons", {
                                  attrs: {
                                    buttons: _vm.selectedTab.QuickAddButtons,
                                    "edit-mode": _vm.gridState.editMode,
                                    "can-edit": _vm.canEditCurrentTab,
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.items.length != 0
                    ? _c(
                        "app-grid-container",
                        {
                          attrs: {
                            cols: 3,
                            state: _vm.gridState,
                            "row-height": 88,
                            "ignore-horizontal-on-mobile": "",
                          },
                        },
                        _vm._l(_vm.items, function (item) {
                          return _c("app-dashboard-item", {
                            key: item.key,
                            ref: "dashboardItems",
                            refInFor: true,
                            attrs: {
                              item: item,
                              state: _vm.gridState,
                              "can-edit": _vm.canEditCurrentTab,
                            },
                            on: {
                              "open-settings": function ($event) {
                                return _vm.openSettings(item)
                              },
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-col",
                {
                  style: { height: _vm.editMode ? undefined : 0 },
                  attrs: {
                    xs: _vm.settingsBarWidth,
                    "width-transition": "",
                    "default-width": 0,
                  },
                },
                [
                  _c("app-settings-bar", {
                    staticClass: "settings-bar",
                    attrs: {
                      settings: _vm.settings,
                      tabs: _vm.tabs,
                      items: _vm.items,
                      "can-edit-current-tab": _vm.canEditCurrentTab,
                    },
                    on: {
                      "tab-deleted": function ($event) {
                        return _vm.loadItems()
                      },
                      sort: function ($event) {
                        return _vm.onTabsSorted()
                      },
                    },
                  }),
                  _c(
                    "w-modal",
                    { attrs: { value: _vm.openedSettingsItem != null } },
                    [
                      _vm.openedSettingsItem
                        ? _c("app-custom-settings", {
                            attrs: { item: _vm.openedSettingsItem },
                            on: {
                              close: function ($event) {
                                _vm.openedSettingsItem = null
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.items.length == 0 && !_vm.editMode
            ? _c("div", { staticClass: "no-permission-to-dashboard welcome" }, [
                _c("div", { staticClass: "text" }, [
                  _c("h1", [
                    _vm._v(_vm._s(_vm.welcomMsg) + " " + _vm._s(_vm.firstName)),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }